"use client";

import AdBanner from "@/assets/images/landingPage/financingBanner.jpg";
import AdBannerMobile from "@/assets/images/landingPage/financingBannerMobile.jpg";
import KitchenPackagesBanner from "@/assets/images/kitchen-packages-banner.webp";
import KitchenPackagesBannerMobile from "@/assets/images/kitchen-packages-banner-mobile.webp";
import LuxuryAppliancesBanner from "@/assets/images/luxury-appliances-banner.webp";
import LuxuryAppliancesBannerMobile from "@/assets/images/luxury-appliances-banner-mobile.png";
import GaggenauBrandAdBanner from "@/assets/images/landingPage/GaggenauCombiMicrowaveCookingDemoSJBanner-DESKTOP.png";
import GaggenauBrandAdBannerMobile from "@/assets/images/landingPage/GaggenauCombiMicrowaveCookingDemoSJBanner-MOBILE.png";
import DynamicImage from "@/components/DynamicImages/DynamicImage";
import FastDeliveryWebBanner from "@/assets/images/landingPage/FastDeliveryNoMatterTheDayWeb.png"
import FastDeliveryMobileBanner from "@/assets/images/landingPage/FastDeliveryNoMatterTheDayMobile.png"

import DashboardBanner from "@/components/Dashboard/Banner";
import CategoryCard from "@/components/Dashboard/CategoryCard";
import {
  FeaturedProductsCard,
  TopDealsCard,
} from "@/components/Dashboard/FeaturedProducts";
import { useRouter } from "next/navigation";
import { dashboardBrandList } from "@/lib/brandData";

import { Button } from "@/components/ui/button";
import { useGetBrandsQuery } from "@/redux/apiSlices/categoriesApi";
import Image from "next/image";
import Link from "next/link";
import NextDayDeliveryBanner from "@/assets/images/landingPageBanner1.webp";
import NextDayDeliveryMobileBanner from "@/assets/images/landingPageMobileBanner1.png";
import { AspectRatio } from "@/components/ui/aspect-ratio";

import DealByCategory from "./DealByCategory";
import ExploreAllLuxuryBrands from "./ExploreAllLuxuryBrands";
import DealByBrand from "./DealByBrand";
import { useDispatch } from "react-redux";
import { AddNewBreadcrum } from "@/redux/slices/breadcrumSlice";
import AsLowAs from "./AsLowAs";
import RebateBanner1 from "@/assets/images/landingPage/RebatesBanner/RebateBanner1.jpg";
import RebateBanner2 from "@/assets/images/landingPage/RebatesBanner/RebateBanner2.jpg";
import RebateBanner3 from "@/assets/images/landingPage/RebatesBanner/RebateBanner3.jpg";
import FreeSetBanner1 from "@/assets/images/landingPage/BOSCHReceiveFreeCookwareSet_Desktop.png";
import FreeSetBanner2 from "@/assets/images/landingPage/SpeedQueenRebateDryers_Desktop.png";
import FreeSetBanner1Mobile from "@/assets/images/landingPage/BoschFreeCookwareSet_Mobile.png";
import FreeSetBanner2Mobile from "@/assets/images/landingPage/SpeedQueenRebateDryers_Mobile.png";
import ThermadorSteamOvenDemoEventImg from "@/assets/images/landingPage/ThermadorSteamOvenDemoEvent_Desktop.png"
import ThermadorSteamOvenDemoEventMobileImg from "@/assets/images/landingPage/ThermadorSteamOvenDemoEvent_Mobile.png"
import BoschBannerDesktop from "@/assets/images/landingPage/BOSCHReceiveFreeCookwareSetDesktop.png"
import BoschBannerMobilep from "@/assets/images/landingPage/BOSCHReceiveFreeCookwareSetMobile.png"

import BoschEspressoMachineBannerDesktop from "@/assets/images/landingPage/BoschEspressoMachineBannerDesktop.png"
import BoschEspressoMachineBannerMobile from "@/assets/images/landingPage/BoschEspressoMachineBannerMobile.png"
const RebateBannerImg = [
  {
    src: RebateBanner1,
    link: "/in-stock?subCategory2Ids=366",
    title: "French Door Refrigerators"
  },
  {
    src: RebateBanner2,
    link: "/in-stock?categoryIds=350",
    title: "Dishwashers"
  },
  {
    src: RebateBanner3,
    link: "/laundry/washer-dryer-sets?page=1&isAvailabilty=true",
    title: "Washer & Dryer Sets"
  },
];

const Dashboard = () => {
  const router = useRouter();

  const { data } = useGetBrandsQuery({
    limit: 6,
    filterBy: "isActive",
    filterValue: "true",
  });
  const brandLinks = ["dcs", "", "avanti", "elica", "foster", "thor-kitchen"];

  const BrandImageTag = ({ src, link, title }) => (
    <li className="px-5 py-4 bg-white rounded-[12px] border-[1px] border-[#F0F0F0] shadow-lg p-2 h-[129px] flex items-center justify-center hover:underline cursor-pointer transition-transform duration-300 transform hover:scale-105">
      <Link
        href={`/${link}`}
        passHref
        rel="noopener noreferrer"
        className="grid grid-cols-1 items-center text-center"
        onClick={() => {
          updateBreadcrumb([
            {
              name: title,
              url: link,
            },
          ]);
        }}
      >
        <div className="w-full h-[50px] flex items-center justify-center overflow-hidden">
          <Image
            src={src}
            className="w-auto h-full object-contain max-w-[135px] mob:max-w-full"
            alt="Brand Logo"
          />
        </div>
      </Link>
    </li>
  );
  const dispatch = useDispatch();
  const updateBreadcrumb = (breadcrumb) => {
    dispatch(AddNewBreadcrum(breadcrumb));
  };

  return (
    <div className=" bg-light-gray lg:bg-mobileBG">
      <DashboardBanner />
      <div className="max-w-[1440px] px-[20px] m-auto lg:px-4">
        <div>
          <div className=" items-center justify-between lg:px-2 hidden lg:flex lg:mb-[2px]">
            <h3 className=" hidden lg:block text-[25px] text-black font-semibold mb-5 leading-[26px] lg:text-[20px] lg:leading-[26px] lg:text-blue1 lg:mb-0 ">
              Featured Products
            </h3>
            <Button
              onClick={() => {
                router.push(`/top-deals`);
                updateBreadcrumb([
                  {
                    name: "Top Deals",
                    url: `/top-deals`,
                  },
                ]);
              }}
              variant="outline"
              className="lg:inline-block hidden font-semibold lg:bg-transparent lg:h-[34px] lg:text-white lg:bg-[#0B223C] lg:text-[12px] lg:py-[5px] lg:leading-[22px] lg:rounded-[50px]"
            >
              Shop All
            </Button>
          </div>

          <div className="flex gap-[7px]">
            <TopDealsCard
              breadcrumHandler={() => {
                updateBreadcrumb([
                  {
                    name: "Top Deals",
                    url: `/top-deals`,
                  },
                ]);
              }}
            />
            <FeaturedProductsCard />
          </div>
        </div>
      </div>

      {/* AsLowAs */}
      {/* <div className="max-w-[1464px] w-full 1440:px-0 px-[20px] m-auto ">
        <AsLowAs updateBreadcrumb={updateBreadcrumb} />
      </div> */}
      
      {/* next-day-delivery */}
      {/* <div className="max-w-[1440px] px-[20px] m-auto lg:px-4 mb-[48px] lg:mb-[24px]">
        <Link href="/next-day-delivery"
           onClick={() => {
            updateBreadcrumb([
              {
                name: "Next Day Delivery",
                url: `/next-day-delivery`,
              },
            ]);
          }} >
          <Image src={FastDeliveryWebBanner} className=" sm:hidden" alt="fast delivery banner" />
          <Image src={FastDeliveryMobileBanner} className="hidden sm:block" alt="fast delivery banner" />
        </Link>
      </div> */}

      {/* rebate and promotinon */}
      <div className="max-w-[1440px] px-[20px] m-auto lg:px-4">
        <div className="grid grid-cols-3 gap-[35px] mb-[48px] lg:gap-6 sm:grid-cols-1  sm:mt-6 sm:mb-6 ">
          {RebateBannerImg.map((item, index) => (
            <div key={index} className=" rounded-[8px] overflow-hidden">
            <Link href={item.link} onClick={() => {
                updateBreadcrumb([
                  {
                    name: item.title,
                    url: item.link,
                  },
                ]);
              }}>
              <AspectRatio ratio={435 / 217} className="bg-muted">
                <DynamicImage
                  src={item.src}
                  alt={`Banner `}
                  fill
                  className="h-full w-full  object-cover"
                />
              </AspectRatio>
          
            </Link>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-[1440px] px-[20px] m-auto lg:px-4">
        <div className=" w-full mb-[48px] lg:mb-[24px] overflow-hidden  ">
          <Link href="/financing">
            <Image src={AdBanner} alt="ad-banner" className=" sm:hidden" />
            <Image
              src={AdBannerMobile}
              alt="ad-banner"
              className=" hidden sm:block "
            />
          </Link>
        </div>
      </div>

   
       <div className="max-w-[1440px] px-[20px] m-auto lg:px-4">
        {/* <DealByCategory /> */}
          <div className=" w-full  overflow-hidden flex gap-10 lg:gap-7 sm:flex-col mb-[48px] lg:mb-[24px]  ">
            <Link
              href="/shop?tag=bosch-induction-cookware-promotion"
              onClick={() => {
                updateBreadcrumb([
                  {
                    name: "BOSCH Induction Cookware Promotion",
                    url: `/shop?tag=bosch-induction-cookware-promotion`,
                  },
                ]);
              }}
            >
              <div className=" rounded-[20px] overflow-hidden sm:rounded-none ">
                <Image
                src={BoschBannerDesktop}
                alt="ad-banner"
                className=" sm:hidden"
              />
              <Image
                src={BoschBannerMobilep}
                alt="ad-banner"
                className=" hidden sm:block "
              />
              </div>
            </Link>
            
            <Link
              href="/coffee-systems/freestanding-coffee-systems?fieldIds=38&fieldValueIds=22663&page=1&brandIds=20"
              onClick={() => {
                updateBreadcrumb([
                  {
                    name: "BOSCH Coffee Systems",
                    url: `/coffee-systems/freestanding-coffee-systems?fieldIds=38&fieldValueIds=22663&page=1&brandIds=20`,
                  },
                ]);
              }}
            >
              <div className=" rounded-[20px] overflow-hidden sm:rounded-none ">
                <Image
                src={BoschEspressoMachineBannerDesktop}
                alt="ad-banner"
                className=" sm:hidden"
              />
              <Image
                src={BoschEspressoMachineBannerMobile}
                alt="ad-banner"
                className=" hidden sm:block "
              />
              </div>
            </Link>
          </div>
        {/* <div className=" w-full mb-[48px] lg:mb-[24px] overflow-hidden  ">
          <Link
            href="/events/gaggenau-combi-microwave-oven-demo-san-jose"
            onClick={() => {
              updateBreadcrumb([
                {
                  name: "Gaggenau Combi Microwave Oven Demo San Jose",
                  url: `/events/gaggenau-combi-microwave-oven-demo-san-jose`,
                },
              ]);
            }}
          >
            <Image src={GaggenauBrandAdBanner} alt="ad-banner" className=" sm:hidden" />
            <Image
              src={GaggenauBrandAdBannerMobile}
              alt="ad-banner"
              className=" hidden sm:block "
            />
          </Link>
        </div> */}
      </div> 
      
     
      
        
        {/* FreeSetBanner1 */}
        {/* <div>
          <div className="   pb-[48px] sm:pb-6">
            <Link href="/shop?tag=bosch-induction-cookware-promotion" onClick={() => {
            updateBreadcrumb([
              {
                name: "BOSCH Induction Cookware Promotion",
                url: `/shop?tag=bosch-induction-cookware-promotion`,
              },
            ]);
          }}>
                <Image
                      src={FreeSetBanner1}
                      alt={`Banner `}
                      
                      className=" object-contain  rounded-10 sm:hidden"
                    />
                    <Image
                      src={FreeSetBanner1Mobile}
                      alt={`Banner `}
                      className=" object-contain hidden sm:block"
                    />
               
            </Link>
             <Link href="/products?brandIds=36&rebateIds=112" onClick={() => {
            updateBreadcrumb([
              {
                name: "Speed Queen",
                url: `/products?brandIds=36&rebateIds=112`,
              },
            ]);
          }}>
              <div>
                <div className="sm:hidden ">
                  <AspectRatio ratio={676 / 322}>
                    <DynamicImage
                      src={FreeSetBanner2}
                      alt={`Banner `}
                      fill
                      className="h-full w-full  object-cover rounded-10"
                    />
                  </AspectRatio>
                </div>
                <div className="hidden sm:block ">
                  <AspectRatio ratio={368 / 318}>
                    <DynamicImage
                      src={FreeSetBanner2Mobile}
                      alt={`Banner `}
                      fill
                      className="h-full w-full  object-cover"
                    />
                  </AspectRatio>
                </div>
              </div>
            </Link> 
          </div>
        </div> */}
     
      {/* <DealByBrand /> */}
      
      {/* thermador for mobile  */}
        {/* <div className="pb-6 hidden sm:block px-4 ">
          <Link href="/events/thermador-steam-oven-cooking-demo-san-jose">
            <Image
              src={ThermadorSteamOvenDemoEventMobileImg}
              alt="ad-banner"
             
            />
          </Link>
        </div> */}
       {/* kitchen packages for mobile */}
      {/* <div className=" w-full mb-[48px] lg:mb-[24px] overflow-hidden hidden sm:block "> 
        <Link 
          href="/kitchen-packages" 
          onClick={() => {
            updateBreadcrumb([
              {
                name: "kitchen Packages",
                url: `/kitchen-packages`,
              },
            ]);
          }}
        >
          
         
        </Link>
      </div> */}
    
    {/* luxury-appliances */}
      <div className=" w-full mb-[48px] lg:mb-[24px] overflow-hidden  ">
       <Link href="/luxury-appliances"> 
          <Image
            src={LuxuryAppliancesBanner}
            alt="ad-banner"
            className=" sm:hidden w-full"
          />
          <Image
            src={LuxuryAppliancesBannerMobile}
            alt="ad-banner"
            className=" hidden sm:block w-full "
          />
         </Link> 
      </div>

      <div className="max-w-[1440px] px-[20px] m-auto lg:px-4">
        {/* AllLuxuryBrands */}

        <ExploreAllLuxuryBrands categoryType="RefrigeratorsFreezers" />
        
        {/* thermador for web */}
        {/* <div className="pb-[48px] sm:hidden">
          <Link href="/events/thermador-steam-oven-cooking-demo-san-jose">
            <Image src={ThermadorSteamOvenDemoEventImg} alt="ad-banner" />
            
          </Link>
        </div> */}

      </div>

      {/* kitchen packages */}
      <div className=" w-full mb-[48px] lg:mb-[24px] overflow-hidden"> 
         <Link 
          href="/kitchen-packages" 
          onClick={() => {
            updateBreadcrumb([
              {
                name: "kitchen Packages",
                url: `/kitchen-packages`,
              },
            ]);
          }}
        > 
          <Image
            src={KitchenPackagesBanner}
            alt="ad-banner"
            className=" sm:hidden w-full"
          />
           <Image
            src={KitchenPackagesBannerMobile}
            alt="ad-banner"
            className=" hidden sm:block w-full"
          />
         </Link> 
      </div>
      
      <div className="max-w-[1440px] px-[20px] m-auto lg:px-4">
          {/* Our Brands */}
        <div className=" pb-[30px] sm:pb-6">
          <div className="flex justify-between items-center mb-[28px] sm:mb-3">
            <h3 className="   text-[25px] text-black font-semibold  leading-[26px] lg:text-[20px] lg:leading-[26px] lg:text-blue1 lg:mb-0 ">
              Our Brands
            </h3>
            <Link
              href="/brands"
              variant="outline"
              className="text-[16px] font-semibold px-[20px] py-[10px] rounded-[30px] bg-[#0B223C] text-white sm:text-[12px] sm:px-4 sm:py-[8px]"
            >
              Browse All Brands
            </Link>
          </div>
          <div className="grid grid-cols-[repeat(auto-fill,minmax(192px,1fr))] gap-[24px] sm:grid-cols-2 sm:gap-3 ">
            {dashboardBrandList?.length > 0 &&
              dashboardBrandList.map((brand, index) => (
                <BrandImageTag
                  key={index}
                  src={brand.src}
                  link={brand.link}
                  title={brand.name}
                />
              ))}
          </div>
        </div>
      </div>

      {/* Shop by Category */}
      <div className="lg:bg-mobileBG pb-6">
        <div className=" py-[26px]   rounded-10  sm:bg-white sm:rounded-none max-w-[1440px] px-[20px] m-auto lg:px-4 sm:px-0 ">
          <h3 className=" mb-[28px] sm:mb-3   text-[25px] text-black font-semibold  leading-[26px] lg:text-[20px] lg:leading-[26px] lg:text-blue1 lg:mb-0 lg:px-6">
            Shop by Category
          </h3>
          <div>
            <CategoryCard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
